import { KullaniciGrup } from './kullanici-grup';

export class SiparisOnaySeviye {
    id: number;
    seviye: number;
    kullaniciGrupId: number;
    kullaniciGrup: KullaniciGrup;

    constructor(obj?: any) {
        if (obj == null)
            return;

        Object.assign(this, obj);
        if (obj.kullaniciGrup != null) {
            this.kullaniciGrup = new KullaniciGrup(obj.kullaniciGrup);
        }

    }
}
